export default __webpack_public_path__ + "static/media/smallcap250-valuation-graph1.b1a288f6.jpg";